__turbopack_context__.v({
  "entriesContainer": "V2EntriesAndDays-module__XBuLNG__entriesContainer",
  "headingContainer": "V2EntriesAndDays-module__XBuLNG__headingContainer",
  "modalsContainer": "V2EntriesAndDays-module__XBuLNG__modalsContainer",
});
